var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.step === 1
        ? _c("voiceConsultation", { on: { complete: _vm.onVoiceComplete } })
        : _vm._e(),
      _vm.step === 2
        ? _c("consultationChoice", {
            attrs: { "diag-info": _vm.diagInfo },
            on: { confirm: _vm.onSymptomConfirm },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }